/** One image from the media library (post cover, og image). Value is a URL. */
import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { DeleteOutlined, FileImageOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../../shared/i18n';
import { MediaPickerModal } from '../Media';

const CoverPicker = ({ siteId, src, onChange }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    return (
        <div>
            {src && <img src={src} alt="" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 6, marginBottom: 8, display: 'block' }} />}
            <Space>
                <Button icon={<FileImageOutlined />} onClick={() => setOpen(true)}>{src ? t('Replace') : t('Choose image')}</Button>
                {src && <Button icon={<DeleteOutlined />} aria-label={t('Remove')} onClick={() => onChange(null)} />}
            </Space>
            <MediaPickerModal open={open} siteId={siteId} kind="image" onClose={() => setOpen(false)} onPick={(m) => onChange(m)} />
        </div>
    );
};

export default CoverPicker;
